<template>
    <svg aria-hidden="true"  :style="styles">
       <use :xlink:href="symbolId" fill="currentColor" />
    </svg>
</template>
<script>
export default {
    name:'SvgIconMe',
 
    props: {
        name: {
            type: String,
            required: true
        },
        size: {
            type:  String,
            default: '16px'
        },
        color: {
            type: String,
            default: 'inherit'
        }
    },
    //计算属性
    computed:{
        styles:function(){
        
            return {
                width: this.size,
                height: this.size,
                color: this.color
            }
        },
        symbolId:function(){
            return `#icon-${this.name}`
        }
    }
}
</script>